<div class="inner-content">
  <div class="flex items-center justify-between">
    <div class="flex flex-row items-center gap-2">
      <ion-icon class="title-icon" icon="assets/icon/alert-red-circle.svg"></ion-icon>
      <div class="title barlow">¡ATENCIÓN!</div>
    </div>
    <ion-icon class="close-icon cursor-pointer" icon="assets/icon/cross.svg" (click)="close()"></ion-icon>
  </div>
  <hr />
  <div class="w-100 flex flex-col gap-4">
    <h3>Vas a cancelar la subida de todos tus documentos. ¿Estás segur&#64;?</h3>
    <p>¡OJO! La subida de TOOOOOODOS los documentos va a ser cancelada.</p>
    <p>Pero tranqui, esto no afecta a los documentos que ya tuvieras subidos a esta carpeta o a otras carpetas.</p>
  </div>
  <hr />
  <div class="w-100 flex flex-row justify-end gap-2.5">
    <ion-button fill="fill" color="medium-dark" class="underline" (click)="close()"> Seguir con la subida </ion-button>
    <ion-button color="danger" (click)="submit()"> Cancelar subida ahora </ion-button>
  </div>
</div>
